module.exports = __webpack_public_path__ + "img/homekv1.409ca746.jpg";